<template lang="html">
  <div id="Create" class="gm-layout-vertical">
    <el-row class="fadeIn">
      <el-col :lg="{span:10, offset:7}" :sm="{span:18, offset:3}" :xs="{span:24}">
        <vs-input label-placeholder="프로젝트 이름(최소 2글자, 최대 40글자)" v-model="projectInfo.name" style="width: 100%;" autofocus />
        <vs-textarea counter="200" label="프로젝트 설명" :counter-danger.sync="counterDanger" v-model="projectInfo.desc" height="1000px" style="margin-top: 12px;" />
        <vs-input label-placeholder="프로젝트 비밀번호(영문 또는 숫자, 최소 4글자)" v-model="projectInfo.pw" type="password" style="width: 100%; margin-top: 24px;" />
        <vs-input label-placeholder="프로젝트 비밀번호 확인" v-model="checkPw" type="password" style="width: 100%; margin-top: 24px;" />
        <div class="gm-layout-horizontal gm-align-vertical-center" style="margin-top: 16px;">
          <el-tooltip class="item" effect="dark" content="프로젝트에 참가하는 총 인원을 입력해주세요." placement="top">
            <vs-icon icon="info" color="primary"></vs-icon>
          </el-tooltip>
          <span style="text-align:center; width: 120px;">참여 인원</span>
          <vs-input-number min="1" style="margin-left:24px; width: 100px;" size="medium" v-model="projectInfo.participantsNum" />
        </div>
        <div class="gm-layout-horizontal gm-align-vertical-center" style="margin-top: 16px;">
          <el-tooltip class="item" effect="dark" content="마커를 팀 수 대로 나눠드립니다." placement="top">
            <vs-icon icon="info" color="primary"></vs-icon>
          </el-tooltip>
          <span style="text-align:center; width: 120px;">팀 수</span>
          <vs-input-number min="1" :max="projectInfo.participantsNum" style="margin-left:24px; width: 100px;" size="medium" v-model="projectInfo.teamsNum" />
        </div>
        <div class="gm-layout-horizontal gm-align-vertical-center" style="margin-top: 16px;">
          <el-tooltip class="item" effect="dark" content="선택한 방식에 따라 마커를 나눕니다." placement="top">
            <vs-icon icon="info" color="primary"></vs-icon>
          </el-tooltip>
          <span style="text-align:center; width: 120px;">마커 분할 방식</span>
          <el-radio-group v-model="projectInfo.markerRule" size="mini" style="margin-left: 24px;">
            <el-radio-button label="distance">거리</el-radio-button>
            <el-radio-button label="random">랜덤</el-radio-button>
          </el-radio-group>
        </div>
        <div class="excel-parse">
          <div class="uploadExcel" v-if="!isTableShowing">
            <UploadExcelComponent :on-success="successExcelParse" :before-upload="beforeUpload" />
          </div>
          <div class="gm-layout-vertical" v-else>
            <div class="gm-layout-horizontal gm-align-vertical-bottom">
              <span style="color: #606266; font-weight: 400; margin-left: 4px; margin-top: auto;">
                {{ 'Total ' + mapData.body.length }}
              </span>
              <div style="margin-bottom: 8px; margin-left: auto;">
                <el-button type="primary" icon="el-icon-delete" size="small" @click="deleteColumn">삭제</el-button>
                <el-button type="primary" icon="el-icon-refresh-left" size="small" style="margin-left: 4px;" @click="initialization">초기화</el-button>
              </div>
            </div>
            <el-table ref="excelTable" :data="mapData.body" border max-height="400" highlight-current-row @selection-change="handleSelectionChange" style="width: 100%;">
              <el-table-column type="selection" align="center" width="55" />
              <el-table-column type="index" label="No." align="center" width="50" />
              <el-table-column v-for="(item, index) of mapData.header" :prop="item.prop" :label="item.prop" :key="index" />
            </el-table>
          </div>
        </div>
        <div align="center" style="margin: 24px;">
          <el-button type="primary" @click="checkValidation" style="width: 200px; font-size: 1.2rem;">프로젝트 생성</el-button>
        </div>
      </el-col>
    </el-row>
    <SelectHeaderDialog :headers="tempMapData.header" :onSuccess="successHeaderSelection" />
  </div>
</template>
<script>
import { searchAddress } from '@/kakao'
import { firestore, db } from '@/firebase'
import UploadExcelComponent from '@/components/Util/UploadExcel'
import SelectHeaderDialog from '@/components/Create/SelectHeaderDialog'

export default {
  name: 'Create',
  components: {
    UploadExcelComponent,
    SelectHeaderDialog
  },
  data: () => ({
    counterDanger: false,
    checkPw: '',
    isTableShowing: false,
    tableHeader: [],
    multipleSelection: [],
    tempMapData: {
      header: [],
      body: []
    },
    mapData: {
      header: [],
      body: []
    },
    projectInfo: {
      pid: '',
      name: '',
      desc: '',
      pw: '',
      participantsNum: 1,
      teamsNum: 1,
      markerRule: 'distance', // distance | random
      createdAt: firestore.FieldValue.serverTimestamp()
    }
  }),
  computed: {
    getState() {
      return this.$store.state
    }
  },
  methods: {
    beforeUpload(file) {
      const isLt1M = file.size / 1024 / 1024 < 1
      if (isLt1M) {
        return true
      }
      this.$message({
        message: 'Please do not upload files larger than 1m in size.',
        type: 'warning'
      })
      return false
    },
    successExcelParse({ header, body }) {
      let uniqueHeaderSet = new Set(header)
      let title = null
      let text = null
      let creatable = false
      if (body.length > 200) {
        // 파싱 제한
        title = '데이터가 ' + body.length + '개로 너무 많아요!'
        text = '최대 200개까지만 가능해요.. 😅'
      } else if (header.length < 2) {
        // 컬럼명 3개 이하
        title = '컬럼 부족하네요!'
        text = '지도를 만들기 위해서는 컬럼이 최소 2개(주소, 이름) 필요해요.'
      } else if (uniqueHeaderSet.size !== header.length) {
        // 컬럼명 중복
        let uniqueHeader = Array.from(uniqueHeaderSet)
        for (let i in uniqueHeader) {
          let index = header.indexOf(uniqueHeader[i])
          header.splice(index, 1)
        }
        title = '컬럼명이 중복되면 안되요!'
        text = header.join(',') + ' 컬럼명이 중복되었네요.'
      } else if (body.length === 0) {
        title = '데이터가 하나도 없네요!'
        text = '데이터를 추가해주세요.'
      } else {
        this.tempMapData.header = header
        this.tempMapData.body = body
        this.$event.$emit(this.$eventList.showSelectHeaderDialog, true)
        creatable = true
      }
      if (!creatable) {
        this.$vs.notify({
          title: title,
          text: text,
          color: 'warning',
          icon: 'error',
          time: 5000,
          position: 'top-center'
        })
      }
    },
    successHeaderSelection(selectedHeaders) {
      // 선택한 컬럼만 넣기
      this.tableHeader = selectedHeaders
      this.mapData.header = selectedHeaders
      for (let i in this.tempMapData.body) {
        this.mapData.body[i] = {}
        for (let j in selectedHeaders) {
          const prop = this.tempMapData.body[i][selectedHeaders[j].label]
          this.mapData.body[i][selectedHeaders[j].prop] = prop
        }
      }
      this.isTableShowing = true
    },
    deleteColumn() {
      if (this.multipleSelection.length === 0) {
        this.$vs.notify({
          title: '선택된 컬럼이 없네요!',
          text: '삭제하실 컬럼을 선택해주세요.',
          color: 'warning',
          icon: 'error',
          time: 5000,
          position: 'top-center'
        })
      } else if (this.multipleSelection.length === this.mapData.body.length) {
        this.initialization()
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '삭제',
          text: '선택하신 ' + this.multipleSelection.length + '개의 컬럼을 삭제할까요?',
          acceptText: '네. 삭제해주세요!',
          cancelText: '아니요. 지우지 말아요!',
          accept: _ => {
            const numlipleSelectionNum = this.multipleSelection.length
            while (this.multipleSelection.length > 0) {
              const selection = this.multipleSelection.pop()
              const index = this.mapData.body.indexOf(selection)
              this.mapData.body.splice(index, 1)
            }
            this.$vs.notify({
              title: '삭제 완료!',
              text: '선택하신 ' + numlipleSelectionNum + '개 컬럼이 삭제 되었어요.',
              color: 'success',
              icon: 'error',
              time: 3000,
              position: 'top-center'
            })
          }
        })
      }
    },
    initialization() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '업로드 초기화',
        text: '파일을 다시 업로드 하실래요?',
        acceptText: '네. 다시 업로드 할래요.',
        cancelText: '아니요. 이대로 유지할래요.',
        accept: _ => {
          this.resetMapData()
          this.$vs.notify({
            title: '초기화 완료!',
            text: '파일을 다시 업로드 해주세요.',
            color: 'success',
            icon: 'error',
            time: 3000,
            position: 'top-center'
          })
        }
      })
    },
    resetMapData() {
      this.mapData = { header: [], body: [] }
      this.isTableShowing = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    /* Check validation */
    checkValidation() {
      this.$vs.loading()
      let creatable = false
      let title = null
      let text = null
      if (this.projectInfo.name.length === 0) {
        title = '프로젝트 이름이 없네요!'
        text = '프로젝트 이름을 입력해주세요.'
      } else if (this.projectInfo.name.length < 2) {
        title = '프로젝트 이름이 너무 짧아요!'
        text = '프로젝트 이름을 최소 2글자 이상 적어주세요.'
      } else if (this.projectInfo.name.length > 40) {
        title = '프로젝트 이름이 너무 길어요!'
        text = '프로젝트 이름을 40글자 이하로 적어주세요.'
      } else if (this.projectInfo.desc.length > 200) {
        title = '프로젝트 설명이 너무 길어요!'
        text = '프로젝트 설명을 200자 이내로 적어주세요.'
      } else if (this.projectInfo.desc.length === 0) {
        title = '프로젝트 설명을 적어주세요!'
        text = '프로젝트 설명이 필요해요.'
      } else if (this.projectInfo.pw.length < 4 && this.projectInfo.pw.length > 0) {
        title = '비밀번호가 너무 짧아요!'
        text = '비밀번호는 최소 4글자 이상 적어주세요.'
      } else if (this.projectInfo.pw.length === 0) {
        title = '비밀번호를 입력해주세요!'
        text = '비밀번호는 프로젝트 접근시 사용되요.'
      } else if (!/^[a-zA-Z0-9+]*$/.test(this.projectInfo.pw)) {
        title = '비밀번호의 형식이 올바르지않아요!'
        text = '비밀번호는 영문 또는 숫자만 가능해요.'
      } else if (this.projectInfo.pw !== this.checkPw) {
        title = '비밀번호가 일치하지 않아요!'
        text = '비밀번호를 확인해주세요.'
      } else if (this.mapData.body.length === 0) {
        title = '지도에 표시할 정보가 없네요!'
        text = '주소가 담긴 Excel 파일을 업로드하세요!'
      } else if (this.mapData.body.length < this.projectInfo.teamsNum) {
        title = '팀 수가 마커 수보다 많아요!'
        text = '팀 수를 ' + this.mapData.body.length + '이하로 선택해주세요!'
      } else {
        creatable = true
      }

      if (!creatable) {
        setTimeout(_ => { this.$vs.loading.close() }, 1)
        this.$vs.notify({
          title: title,
          text: text,
          color: 'warning',
          icon: 'error',
          time: 3000,
          position: 'top-center'
        })
      } else {
        this.$log.d('converting address to coordinate...')
        this.addressToCoordinateCaller()
      }
    },
    addressToCoordinateCaller() {
      const total = this.mapData.body.length
      this.addressToCoordinate(total, 0)
    },
    addressToCoordinate(total, i) {
      if (i === total) {
        this.calcurateNumOfMarkersPerTeam()
        return
      }
      const address = this.mapData.body[i]['address']
      let title = null
      let text = null
      searchAddress(address).then(data => {
        if (data.documents.length === 0) {
          // 일치하는 주소 없음
          this.$log.w('주소 파싱 실패 :', address)
          title = '주소가 잘못된 것 같아요!'
          text = '요청하신 \'' + address + '\' 주소를 확인해주세요.'

          this.$vs.loading.close()
          this.$vs.notify({
            title: title,
            text: text,
            color: 'warning',
            icon: 'error',
            time: 10000,
            position: 'top-center'
          })
        } else if (['ROAD_ADDR', 'REGION_ADDR '].indexOf(data.documents[0].address_type) === -1) {
          let addressType = null
          if (data.documents[0].address_type === 'REGION') {
            addressType = '지역명'
          } else {
            addressType = '도로명'
          }
          title = '주소를 확인해주세요!'
          text = '요청하신 주소 [' + address + ']가 [' + addressType + '] 단위로 정확한 위치가 아닙니다. 그래도 계속 진행할까요?'

          this.$vs.loading.close()
          this.$vs.dialog({
            type: 'confirm',
            color: 'danger',
            title: title,
            acceptText: '네. 계속 진행해주세요.',
            cancelText: '아니요. 수정할게요.',
            text: text,
            accept: _ => {
              this.$vs.loading()
              this.mapData.body[i]['x'] = data.documents[0].x
              this.mapData.body[i]['y'] = data.documents[0].y
              this.addressToCoordinate(total, i + 1)
            }
          })
        } else {
          this.mapData.body[i]['x'] = data.documents[0].x
          this.mapData.body[i]['y'] = data.documents[0].y
          this.addressToCoordinate(total, i + 1)
        }
      }).catch(err => {
        this.$vs.loading.close()
        this.$log.w('err occured', err)
        this.$vs.notify({
          title: 'Error Occured!',
          text: err,
          color: 'warning',
          icon: 'error',
          time: 10000,
          position: 'top-center'
        })
      })
    },
    calcurateNumOfMarkersPerTeam() {
      const numOfMarks = this.mapData.body.length
      const numOfTeam = this.projectInfo.teamsNum

      // Calcurate number of markers per team.
      const numOfMarkersPerTeam = []
      numOfMarkersPerTeam.length = numOfTeam
      numOfMarkersPerTeam.fill(parseInt(numOfMarks / numOfTeam))
      for (let o = 0; o < (numOfMarks % numOfTeam); o++) {
        numOfMarkersPerTeam[o] += 1
      }
      this.$log.d('numOfMarkersPerTeam', numOfMarkersPerTeam)

      if (this.projectInfo.markerRule === 'random') {
        this.$log.d('marker role : random')
        this.devideMarkersByRandom(numOfMarks, numOfTeam, numOfMarkersPerTeam)
      } else {
        this.$log.d('marker role : distance')
        this.devideMarkersByDistance(numOfMarks, numOfTeam, numOfMarkersPerTeam)
      }
    },
    devideMarkersByRandom(numOfMarks, numOfTeam, numOfMarkersPerTeam) {
      let unteamedMarkers = JSON.parse(JSON.stringify(this.mapData.body)) // deep copy using JSON
      let teamedMarkers = []
      for (let i = 0; i < numOfTeam; i++) {
        for (let j = 0; j < numOfMarkersPerTeam[i]; j++) {
          let index = Math.floor(Math.random() * unteamedMarkers.length)
          if (teamedMarkers[i] === undefined) {
            teamedMarkers[i] = {}
          }
          teamedMarkers[i][j] = unteamedMarkers[index]
          unteamedMarkers.splice(index, 1)
        }
      }

      // create marker state
      this.createMarkerState(teamedMarkers)
    },
    devideMarkersByDistance(numOfMarks, numOfTeam, numOfMarkersPerTeam) {
      const distance = (p1, p2) => {
        let dx = p2.x - p1.x
        let dy = p2.y - p1.y
        return Math.sqrt(dx * dx + dy * dy)
      }

      const getStartingPoint = markers => {
        // Extract xs, ys
        const xs = []
        const ys = []
        markers.map(marker => {
          xs.push(Number(marker.x))
          ys.push(Number(marker.y))
        })

        // Calculate leftTop point
        const leftTop = {
          x: Math.min.apply(null, xs),
          y: Math.max.apply(null, ys)
        }
        this.$log.d('leftTop', leftTop)

        // Find nearest point to the leftTop and set that startPoint
        let nearest = {
          index: 0,
          distance: 999999999999999999999999
        }
        markers.map((marker, i) => {
          const dist = distance(leftTop, marker)
          if (nearest.distance > dist) {
            nearest.index = i
            nearest.distance = dist
          }
        })

        // Remove starting poing
        let startPoint = markers[nearest.index]
        markers.splice(nearest.index, 1)
        return startPoint
      }

      // Team distribution
      let unteamedMarkers = JSON.parse(JSON.stringify(this.mapData.body)) // deep copy using JSON
      let teamedMarkers = []
      for (let i = 0; i < numOfTeam; i++) {
        let startPoint = getStartingPoint(unteamedMarkers)

        for (let j = 0; j < numOfMarkersPerTeam[i]; j++) {
          if (teamedMarkers[i] === undefined) {
            teamedMarkers[i] = {}
            teamedMarkers[i][j] = startPoint
            continue
          }
          let distances = []

          unteamedMarkers.map((marker, index) => {
            distances.push(distance(startPoint, marker))
          })
          let minDistance = Math.min.apply(null, distances)
          let minIndex = distances.indexOf(minDistance)

          this.$log.d('distances', distances)
          this.$log.d('minDistance', minDistance)
          this.$log.d('minIndex', minIndex)
          teamedMarkers[i][j] = unteamedMarkers[minIndex]

          unteamedMarkers.splice(minIndex, 1)
          this.$log.d('this.mapData.body length', this.mapData.body.length)
          this.$log.d(unteamedMarkers.length)
        }
      }

      // create marker state
      this.createMarkerState(teamedMarkers)
    },
    createMarkerState(teamedMarkers) {
      /* markerState
       * [
       *  { teamIndex: 0
       *    markerIndex: 0
       *    state: false
       *  } ...
       * ]
       */
      let markerState = []
      teamedMarkers.map((markers, i) => {
        for (let j in markers) {
          markerState.push({
            teamIndex: i,
            markerIndex: Number(j),
            state: false
          })
        }
      })

      this.$log.d('teamedMarkers', teamedMarkers)
      this.$log.d('markerState', markerState)
      this.$log.d('this.mapData.body', this.mapData.body)
      this.createProject(teamedMarkers, markerState)
    },
    createProject(teamedMarkers, markerState) {
      this.$log.d('start to create', Date.now())

      const userId = 'uid_' + String(this.getState.user.id)
      const projectId = 'pid_' + String(Date.now())

      // users / uid / projects / pid
      const uidRef = db.collection('users').doc(userId)
      const pidRef = uidRef.collection('projects').doc(projectId)

      // ~ / info
      const infoRef = pidRef.collection('info')
      const projectRef = infoRef.doc('project')
      const markersRef = infoRef.doc('markers')

      // ~ / state
      const stateRef = pidRef.collection('state')

      // batch
      let batch = db.batch()
      batch.set(uidRef, {})
      batch.set(pidRef, {})

      // Create info/project
      this.projectInfo['pid'] = projectId
      this.projectInfo['teamsNum'] = Number(this.projectInfo.teamsNum)
      this.projectInfo['markersNum'] = this.mapData.body.length
      batch.set(projectRef, this.projectInfo)

      // Create info/markers
      batch.set(markersRef, { team: teamedMarkers })

      // Create state
      for (let i in markerState) {
        const id = `${markerState[i].teamIndex}${markerState[i].markerIndex}`
        batch.set(stateRef.doc(id), markerState[i])
      }

      // Commit the batch
      this.$log.d('batch start')
      batch.commit().then(() => {
        this.$log.d('batch done')
        this.$vs.loading.close()
        this.$vs.notify({
          title: '프로젝트 생성 완료',
          text: '프로젝트가 생성되었어요.',
          color: 'success',
          icon: 'done',
          time: 5000,
          position: 'top-center'
        })

        // Move to projects
        this.$router.push('projects/' + this.getState.user.id)
      })
    }
  }
}

</script>
<style lang="scss" scoped>
#Create {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 16px;
  font-size: 1.1rem;

  ul {
    list-style: none;
  }

  .excel-parse {
    margin-top: 32px;
  }

  vs-textarea-primary-focusx {
    background-color: red;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Create/index.vue